import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index.js'

import TheNewHeader from './ui/TheHeader.vue'
import TheHeader from './ui/TheNavbar.vue'
import BaseHomeBox from './ui/BaseHomeBox.vue'
import BaseInfoBar from './ui/BaseInfoBar.vue'
import TheFooter from './ui/TheFooter.vue'
import BaseModal from './ui/BaseModal.vue'
import AlertModal from './ui/AlertModal.vue'
import BaseSpinner from './ui/BaseSpinner.vue'
import RightBannerTemplate from './ui/RightBannerTemplate.vue'
import RightLongBannerTemplate from './ui/RightLongBannerTemplate.vue'
import PreviewModal from './ui/PreviewModal.vue'
import SubscribeModal from './ui/SubscribeModal.vue'
import ImageModal from './ui/ImageModal.vue'
import ApplicationSuccessModel from './ui/ApplicationSuccessModel.vue'
import './assets/css/sb-admin.css'

import 'vue-toast-notification/dist/theme-bootstrap.css'
import { showSuccess, showError, checkPermission } from './utils/globalFunctions'
import axios from 'axios'
import SanitizePlugin from './plugins/sanitize'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(SanitizePlugin)
// app.use(ToastPlugin)
app.component('the-new-header', TheNewHeader)
app.component('the-header', TheHeader)
app.component('base-home-box', BaseHomeBox)
app.component('base-info-bar', BaseInfoBar)
app.component('the-footer', TheFooter)
app.component('base-modal', BaseModal)
app.component('alert-modal', AlertModal)
app.component('base-spinner', BaseSpinner)
app.component('right-banner-template', RightBannerTemplate)
app.component('right-long-banner-template', RightLongBannerTemplate)
app.component('preview-modal', PreviewModal)
app.component('subcribe-modal', SubscribeModal)
app.component('app-success-modal', ApplicationSuccessModel)
app.component('image-modal', ImageModal)

app.config.globalProperties.$showSuccess = showSuccess
app.config.globalProperties.$showError = showError
app.config.globalProperties.$checkPermission = checkPermission
const initialStore = localStorage.getItem('storeLocal')

if (initialStore) {
  store.commit('initialise', JSON.parse(initialStore))
  store.dispatch('initializeAxios', store.state.token)
}

axios.interceptors.response.use(
  response => {
    // Xử lý phản hồi thành công
    return response
  },
  error => {
    // Kiểm tra nếu mã trạng thái là 401
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      // Xóa token (nếu cần)
      localStorage.removeItem('storeLocal')

      // Chuyển hướng đến trang đăng nhập
      router.push({ path: '/login' })
    }

    // Trả lỗi cho các phần khác của ứng dụng
    return Promise.reject(error)
  }
)
app.mount('#app')
